import { Directive, HostListener, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HistoryRequest } from "../shared/interfaces/history-request";
import { HistoryComponent } from "./history.component";
import { ListingHistoryService } from "./listing-history.service";
import { ListingAuditService } from "./listing-audit.service";

@Directive({
	selector: "[nstarHistory]",
})
export class HistoryDirective {
	@Input() nstarHistory: HistoryRequest;
	@HostListener("click") onClick() {
		if (!!this.nstarHistory.listingSK) {
			this.listingHistoryService.getWithQuery({
				listingSK: String(this.nstarHistory.listingSK ?? ""),
			});

			this.listingAuditService.getWithQuery({
				listingSK: String(this.nstarHistory.listingSK ?? ""),
			});
			const modalRef = this.ngbModal.open(HistoryComponent, {
				centered: true,
				scrollable: true,
				size: "xl",
			});

			modalRef.componentInstance.listingOrganizationSK = this.nstarHistory.listingOrganizationSK;
		}
	}

	constructor(
		private listingHistoryService: ListingHistoryService,
		private listingAuditService: ListingAuditService,
		private ngbModal: NgbModal
	) {}
}
